(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('ForgotPasswordController', ForgotPasswordController)

    /** @ngInject */
    function ForgotPasswordController(PersonService, LoadingHelper) {
        const vm = this;

        vm.recoverPassword = () => {
            LoadingHelper.startLoading('.loading-holder');

            PersonService
                .requestPasswordChange(vm.forgotData.Login)
                .then(success => {
                    vm.recoverEmail = success;
                    vm.step = 2;
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        init();

        function init() {
            vm.recoverEmail = null;
            vm.step = 1;
        }
    }
}());